export class UpdateStudentStatusModel {
  studentId: number;
  status: number;
}
